import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import passwordStore from '@/store/modules/password';
import { ConditionObject, ValidateObject, PassObj } from '@/Model/model';
import APP_CONST from '@/constants/AppConst';
import UIkit from 'uikit';
import EmailInviteSent from '../../components/familyPortal/popupComponents/emailInviteSent/EmailInviteSent.vue';
import ForgotPassword from '../../components/familyPortal/popupComponents/forgetPassword/ForgotPassword.vue';
import commonEntry from '@/store/modules/commonEntry';
import { ScreenText } from '@/lang/ScreenText';
import AccountSettings from '@/mixins/accountSettings.mixin';

@Component({
  components: {
    'forgot-password': ForgotPassword,
    'email-sent': EmailInviteSent
  }
})
export class PasswordComponent extends Mixins(AccountSettings) {
  @Prop({ default: false })
    typeobj!: PassObj;

  @Prop()
    submitResponse: any;

  @Prop()
    errorMessage!: boolean;

  @Prop()
    reload!: boolean;

  @Prop()
    passwordLength!: any;

  @Prop()
    passwordValidation!: any;

  @Prop()
    closeChangePassword: any;

  @Prop()
    closeErrorMsgPassword!: boolean;

  public readonly APP_ROUTES = APP_CONST.APP_ROUTES;
  public typeInput: string = APP_CONST.PASSWORD;
  public typeReInput: string = APP_CONST.PASSWORD;
  public typeOldInput: string = APP_CONST.PASSWORD;
  public changeClassType: string = '';
  public showError: boolean = APP_CONST.FALSE;
  public passLength: any = 0 || '';
  public oldpassLength: any = 0 || '';
  public confirmpassLength: any = 0 || '';
  public isErrorPassword: boolean = false;
  public errorPasswordMessage = "For security, your password must contain one uppercase letter, one lowercase letter, one number, and at least one of these special characters (!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~).";
  public refSource: any = 'web';
  private objScreenText: ScreenText = new ScreenText();

  @Watch('submitResponse')
  onChildChanged(val: any) {
    this.onSubmuitResponse(val);
  }

  @Watch('reload')
  onReload() {
    this.typeInput = APP_CONST.PASSWORD;
    this.typeReInput = APP_CONST.PASSWORD;
    this.typeOldInput = APP_CONST.PASSWORD;
    this.showError = false;
  }

  @Watch('errorMessage')
  onErrorMessage(val: any) {
    if (val === APP_CONST.TRUE) {
      this.isErrorPassword = val;
    }
  }
  @Watch('closeChangePassword')
  onCloseChangePassword() {
    this.passLength = '';
    this.confirmpassLength = '';
    this.oldpassLength = '';
    this.isErrorPassword = false;
  }

  onSubmuitResponse(val: any) {
    const response = Object.entries(val);
    if (response.length == 4 && response[1][1] == 400) {
      if (this.submitResponse.data.Message == 'Trouble with your password? Click on the forgot password link if you need to reset it.') {
        this.submitResponse.data.Message = this.getScreenText('Error_Incorrect_Password');
      }
      else if (this.submitResponse.data.Message == "Whoops! Looks like we can't find that account. Please contact your program administrator.") {
        this.submitResponse.data.Message = this.getScreenText('Error_Access_Revoked');
      }
      else {
        this.submitResponse.data.value = this.getScreenText('ERROR_LOGIN_RES');
      }
    }
    if (Object.keys(val).length > 0) {
      this.showError = APP_CONST.TRUE;
    }
    else {
      this.showError = APP_CONST.FALSE;
    }
  }

  onClick() {
    this.$gtm && this.$gtm.trackEvent({
      event: null,
      category: 'Password Page',
      action: 'click',
      label: 'Password page Click Event Activated',
      value: 5000,
      noninteraction: false,
    });
  }

  public getScreenText(key: string): string {
    return this.objScreenText.getScreenText(key);
  }

  mounted() {
    if (this.$route !== undefined && this.$gtm !== undefined) {
      this.$gtm.trackView(this.$route.name, this.$route.path);
    }
  }

  get rules(): Array<ConditionObject> {
    return passwordStore.getRules;
  }

  get oldPassword(): string {
    return passwordStore.getOldPassword;
  }

  set oldPassword(password: string) {
    passwordStore.setOldPassword(password);
  }

  get password(): string {
    return passwordStore.getPassword;
  }

  get confirmPassword(): string {
    return passwordStore.getConfirmPassword;
  }

  set password(password: string) {
    passwordStore.setPassword(password);
  }

  set confirmPassword(password: string) {
    passwordStore.setConfirmPassword(password);
  }

  public passwordValidity(object: ValidateObject) {
    passwordStore.setIsPasswordValid(object);
  }

  public handleKeys(event: any, type?: string) {
    this.showError = false;
    const key = event.key;
    commonEntry.submitMutate({ status: 0, data: { isBxPortal: false, name: '' } });
    if (key == 'Backspace') {
      this.isErrorPassword = false;
    }
    this.passLength = this.password.length;
    this.confirmpassLength = this.confirmPassword.length;
    this.oldpassLength = this.oldPassword.length;
    if (event.keyCode === 13) {
      this.$emit('handleEnterCall');
    }
    if ((type === 'oldPassword') && (!this.oldPassword)) {
      this.$emit('oldPasswordError');
    }
  }


  public toggleShowPassword(typeToggle: string): void {
    const typeCheck = (typeInput: string) => {
      return typeInput === APP_CONST.PASSWORD
        ? APP_CONST.TEXT
        : APP_CONST.PASSWORD;
    };
    if (typeToggle === APP_CONST.ENTER_PASS) {
      this.typeInput = typeCheck(this.typeInput);
    }
    else if (typeToggle === APP_CONST.OLD_PASS) {
      this.typeOldInput = typeCheck(this.typeOldInput);
    }
    else {
      this.typeReInput = typeCheck(this.typeReInput);
    }
  }


  public showStrengthString(): string {
    const classType = this.changeClassType;
    const colourVariables = APP_CONST.STRENGTH_COLORS_LIST;
    let strToReturn: string = '';
    switch (classType) {
      case colourVariables[APP_CONST.ZERO]:
        strToReturn = APP_CONST.STRONG;
        break;

      case colourVariables[APP_CONST.ONE]:
        strToReturn = APP_CONST.MEDIUM;
        break;

      case colourVariables[APP_CONST.TWO]:
        strToReturn = APP_CONST.WEAK;
        break;
    }
    return strToReturn;
  }

  get changedType(): string {
    return this.typeInput;
  }

  get changeReType(): string {
    return this.typeReInput;
  }

  get changeOldType(): string {
    return this.typeOldInput;
  }

  public checkfortick(errorsNew: any, message: string): boolean {
    return (errorsNew.indexOf(message) === APP_CONST.MINUSONE);
  }

  public indicatorStrength(errorLength: number, index: number): string {
    const correctedHints: number = APP_CONST.FOUR - errorLength;
    let strClassName = '';
    if (correctedHints === APP_CONST.ZERO && index === APP_CONST.ONE) {
      strClassName = this.changeClassType;
    }
    if ((errorLength === APP_CONST.ONE || errorLength === APP_CONST.TWO) && index < APP_CONST.THREE) {
      strClassName = this.changeClassType;
    }
    else if ((errorLength !== APP_CONST.ONE && errorLength !== APP_CONST.TWO) && index <= correctedHints) {
      strClassName = this.setClassName();
    }
    return strClassName;
  }

  setClassName() {
    return this.changeClassType;
  }

  get confirmPasswordCheck(): string {
    let strReturnValue: string = '';
    if (this.password.length !== APP_CONST.ZERO && this.confirmPassword.length !== APP_CONST.ZERO) {
      strReturnValue = 'false';
      if (this.confirmPassword === this.password) {
        strReturnValue = 'true';
      }
    }
    return strReturnValue;
  }

  get validatePassword(): ValidateObject {
    const errors = [];
    for (const condition of this.rules) {
      if (!condition.regex.test(this.password)) {
        errors.push(condition.message);
      }
    }
    if (errors.length === APP_CONST.ZERO) {
      this.changeClassType = APP_CONST.STYLE_GREEN;
    }
    else {
      if (errors.length === APP_CONST.ONE || errors.length === APP_CONST.TWO) {
        this.changeClassType = APP_CONST.STYLE_YELLOW;
      }
      else {
        this.changeClassType = APP_CONST.STYLE_RED;
      }
    }
    const valid = errors.length === 0
      ? true
      : false;
    this.passwordValidity({ valid, errors });
    return { valid, errors };
  }

  public beforeMount(): void {
    this.resetPasswordStore();
  }

  resetPasswordStore() {
    if (this.password.length !== APP_CONST.ZERO || this.confirmPassword.length !== APP_CONST.ZERO) {
      passwordStore.setOldPassword('');
      passwordStore.setPassword('');
      passwordStore.setConfirmPassword('');
    }
  }

  public adjustPopup() {
    /* istanbul ignore else */
    if (UIkit.modal('#modal-close-default')) {
      UIkit.modal('#modal-close-default').hide();
    }
    /* istanbul ignore else */
    if (UIkit.modal('#modal-email-sent')) {
      UIkit.modal('#modal-email-sent').show();
    }
  }

  close() {
    UIkit.modal('#forgot-confirm-popup').hide();
    UIkit.modal('#modal-close-default').hide();
    UIkit.modal('#modal-email-sent').hide();
  }

  openForgotPopup() {
    /* istanbul ignore else */
    if (UIkit.modal('#modal-close-default')) {
      UIkit.modal('#modal-close-default').show();
      const el: any = document.getElementById('modal-close-default');
      if (el) {
        el.classList.add('uk-open');
        el.style.display = 'block !important';
      }

    }
  }

}